import React, { useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import useOnClickOutside from '../../hooks/useOnClickOutside';
import { ReactSVG } from 'react-svg';
import { getPathAfterBuild } from '../../util/file';
import { RootState } from '../../modules';
import { switchTestGroup, syncTestGroupContents, requestOpenPreview } from '../../modules/editor';
import useAlert from '../../hooks/useAlert';
import { getHtml } from '../../modules/editor/service';


function ContentsAbtestDropdown() {
  const [open, setOpen] = useState(false);

  const emailId = useSelector((state: RootState) => state.editor.email.id);
  const group = useSelector((state: RootState) => state.editor.testGroup);

  const dispatch = useDispatch();
  const Alert = useAlert();

  const iconImage = (path) => {
		const context = require.context('../../assets/images/', true);
		return getPathAfterBuild(context, path);
	};

  const toggleOpen = () => {
    setOpen(!open);
  };

  const onSwitchGroup = (selectedGroup) => {
    if (selectedGroup === group) return;

    dispatch(switchTestGroup(emailId));
    toggleOpen();
  };

  const onClickSyncContents = async () => {
    const targetGroup = group === 'A' ? 'B' : 'A';

    const response = await getHtml(emailId, targetGroup);
    if (response === 'NoHTMLExist') {
      Alert.error(`테스트 그룹 ${targetGroup}의 콘텐츠가 없습니다. 테스트 그룹 B를 편집해 주세요.`)
      return;
    };

    const confirmMsg = `테스트 그룹 ${targetGroup}의<br /> 콘텐츠를 불러오시겠습니까?`;
    const confirmMsgsub = (
      <>
        <p>
          콘텐츠를 불러오면 편집하던 내용은 사라집니다.<br />
          현재 편집 버전: 테스트 그룹 {group}
        </p>
        <a onClick={()=> {
          dispatch(requestOpenPreview());
          window.parent.postMessage({ msg: 'openPreviewModal', emailId: emailId, initialTestGroup: targetGroup }, '*');
        }} >테스트 그룹 {targetGroup} 미리보기</a>
      </>
    );

    Alert.confirm(confirmMsg, () => {
      dispatch(syncTestGroupContents(emailId));
		}, {
      msgsub: confirmMsgsub,
    });
  };

  const ref = useRef<HTMLDivElement>(null);
  useOnClickOutside(ref, ():any => {
    setOpen(false);
  });
  
  return (
    <div className='select-contents-abtest' ref={ref}>
      <div className={open ? 'header open' : 'header'} onClick={toggleOpen}>
        <strong>테스트 그룹 {group}</strong>
        <ReactSVG className='caret' src={iconImage(`./icon/toolbar/arrow_down.svg`)} width='10' />
        {
          open &&
          <div className='body'>
            <ul>
              <li key='A'>
                <button type='button' className={group === 'A' ? 'selected' : ''} onClick={() => onSwitchGroup('A')}>테스트 그룹 A</button>
              </li>
              <li key='B'>
                <button type='button' className={group === 'B' ? 'selected' : ''} onClick={() => onSwitchGroup('B')}>테스트 그룹 B</button>
              </li>
              <li key='sync'>
                <button type='button' className='sync-contents' onClick={onClickSyncContents}>
                  <div className='sync-contents-title'>콘텐츠 불러오기</div>
                  <span className='sync-contents-desc'>
                    현재 편집 중인 버전에 테스트 그룹 {group === 'A' ? 'B' : 'A'}의<br />
                    콘텐츠를 불러옵니다.
                  </span>
                </button>
              </li>
            </ul>
          </div>
        }
      </div>
    </div>
  )
}

export default ContentsAbtestDropdown;